import { render, staticRenderFns } from "./ConfirmDeleteAccount.vue?vue&type=template&id=b6271f66&scoped=true"
import script from "./ConfirmDeleteAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteAccount.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDeleteAccount.vue?vue&type=style&index=0&id=b6271f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6271f66",
  null
  
)

export default component.exports